<template>
  <div class="broadcasts">
    <h2 class="headline mb-3">LON {{ $t('Broadcast') }}</h2>
    <div class="mb-3">
      <v-layout class="wrap" :style="{ margin: '-0.25rem' }">
        <v-flex xs12 sm4 class="pa-1">
          <v-autocomplete
            :value="filter.categoryId"
            :items="categoryOptions"
            :placeholder="$t('Category')"
            outline
            single-line
            hide-details
            clearable
            @input="filter = { ...filter, categoryId: $event }"
          />
        </v-flex>
        <v-flex xs12 sm8 class="pa-1">
          <v-text-field
            :value="filter.search"
            :placeholder="$t('Broadcast Name')"
            prepend-inner-icon="search"
            outline
            single-line
            hide-details
            clearable
            @input="debounceSearch($event)"
          />
        </v-flex>
      </v-layout>
      <DateFilter
        :default-filter="filter.date.filter"
        :value="filter.date"
        class="mt-2"
        @input="filter = { ...filter, date: $event }"
      />
    </div>
    <div style="margin-bottom: 15px">
      <div class="add-broadcast text-xs-center" @click="handleCreateBroadcast">
        <em class="fa fa-plus middle" />
        {{ $t('Add new broadcast') }}
      </div>
    </div>
    <LonBroadcastDraft
      ref="broadcastDraft"
      :category-options="categoryOptions"
      :filter="filter"
      @edit="handleEdit"
      @copy="handleCopyBroadcast"
      @delete="handleDelete"
      @select="handleSelect"
    />
    <LonBroadcastSent
      ref="broadcastSent"
      :category-options="categoryOptions"
      :filter="filter"
      @edit="handleEdit"
      @copy="handleCopyBroadcast"
      @delete="handleDelete"
      @select="handleSelect"
    />
  </div>
</template>
<script>
import LonBroadcastDraft from './LonBroadcastDraft.vue'
import LonBroadcastSent from './LonBroadcastSent.vue'
import lineOfficialNotificationApi from '@/api/line-official-notification'
import { mapGetters } from 'vuex'
import { PAGE_GROUP } from '@/constants/page'
import debounce from 'lodash/debounce'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import dayjs from 'dayjs'

export default {
  components: {
    LonBroadcastDraft,
    LonBroadcastSent,
    DateFilter
  },
  props: {
    categoryOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      debounceSearch: undefined,
      filter: {
        categoryId: this.$route.query.category_id
          ? Number(this.$route.query.category_id)
          : undefined,
        search: this.$route.query.search || '',
        date: {
          start: this.$route.query.start_date
            ? dayjs(this.$route.query.start_date).startOf('day').format('YYYY-MM-DD HH:mm')
            : dayjs().startOf('day').subtract(7, 'day').format('YYYY-MM-DD HH:mm'),
          end: dayjs(this.$route.query.end_date).endOf('day').format('YYYY-MM-DD HH:mm'),
          filter: this.$route.query.date_range_name || 'last_7_days'
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    filter(value) {
      this.$router.replace({
        query: {
          category_id: value.categoryId,
          search: value.search,
          start_date: dayjs(value.date.start).format('YYYY-MM-DD'),
          end_date: dayjs(value.date.end).format('YYYY-MM-DD'),
          date_range_name: value.date.filter
        }
      })
    }
  },
  created() {
    this.debounceSearch = debounce((value) => {
      this.filter = { ...this.filter, search: value }
    }, 500)
  },
  methods: {
    async getDetail({ id }) {
      try {
        const response = await lineOfficialNotificationApi.getLogLineOfficialNotificationBroadcast({
          params: {
            page_id: this.selectedBot.pageid,
            id
          }
        })

        if (response.status === 200) {
          return response.data
        }
      } catch (error) {
        console.error(error)
      }
    },
    handleCreateBroadcast() {
      this.$emit('create-broadcast')
    },
    async handleEdit(broadcast) {
      const detail = await this.getDetail(broadcast)
      if (!detail) return
      this.$emit('edit', detail)
    },
    async handleCopyBroadcast(broadcast) {
      const detail = await this.getDetail(broadcast)
      if (!detail) return
      this.$emit('copy', detail)
    },
    handleDelete(broadcast) {
      this.$emit('delete', broadcast)
    },
    handleSelect(broadcast) {
      this.$emit('select', broadcast)
    },
    handleReFetch() {
      if (this.$refs.broadcastDraft) this.$refs.broadcastDraft.handleReFetch()
      if (this.$refs.broadcastSent) this.$refs.broadcastSent.handleReFetch()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/LonBroadcast/LonBroadcastList.vue